import TrendingSash from './trendingSash'

export default TrendingSash
